// TeacherWeekStrip.js
// "Last {weeks} weeks" summary card for the selected class: active/total
// students, average mastery (omitted when unknown), questions and quizzes.
// See docs/superpowers/specs/2026-09-16-home-redesign.md §4/§5.
import React from "react";
import { View, StyleSheet } from "react-native";

import HomeCard from "../primitives/HomeCard";
import HomeStat from "../primitives/HomeStat";

const identity = (s) => s;

const TeacherWeekStrip = ({ weekStats = null, weeks = 4, isDarkMode = false, t = identity }) => {
  const stats = weekStats || {};
  const title = t("Last {weeks} weeks", { weeks });

  return (
    <HomeCard title={title} isDarkMode={isDarkMode} testID="teacher-week-strip">
      <View style={styles.row}>
        <HomeStat
          value={`${stats.active ?? 0}/${stats.total ?? 0}`}
          label={t("active")}
          isDarkMode={isDarkMode}
        />
        {stats.avgMastery != null ? (
          <HomeStat
            value={`${Math.round(stats.avgMastery * 100)}%`}
            label={t("avg mastery")}
            isDarkMode={isDarkMode}
          />
        ) : null}
        <HomeStat value={stats.questions ?? 0} label={t("questions")} isDarkMode={isDarkMode} />
        <HomeStat value={stats.quizzes ?? 0} label={t("quizzes")} isDarkMode={isDarkMode} />
      </View>
    </HomeCard>
  );
};

const styles = StyleSheet.create({
  row: { flexDirection: "row", flexWrap: "wrap", gap: 20 },
});

export default TeacherWeekStrip;
